export class FilenameParser {
  static fromContentDispositionHeader(header: string | null, defaultValue = 'file.txt'): string {
    const filename = (header || '')
      ?.split('filename=')[1]
      ?.split(';')[0] || defaultValue;

    try {
      // tenta remover aspas do começo e do final do nome do arquivo
      return JSON.parse(filename)
    } catch {
      //caso não existam aspas, retorna o nome do arquivo original
      return filename;
    }
  }
}
